<script setup>
import { useWebSiteStore } from '@/stores/website.store'
import { useRoute } from 'vue-router'
import { computed } from 'vue'

const websiteStore = useWebSiteStore()
const route = useRoute()
const menuItems = computed(() => websiteStore.menuItems())

const isActive = (item) => {
  return item.route?.some(r => r === route.path)
}
</script>

<template>
  <q-footer
    class="bg-white text-dark"
    elevated
  >
    <q-tabs
      active-color="#1DAB61"
      indicator-color="#1DAB61"
    >
      <template
        v-for="(item, index) in menuItems"
        :key="item.id"
      >
        <q-route-tab
          :icon="item.icon"
          :to="item.canAccess ? item.route?.[0] : undefined"
          :class="{ 'text-primary': isActive(item), 'text-disabled': !item.canAccess }"
          :disable="item.canAccess === false"
          @click="item.canAccess!== false && item.onClick()"
        />

        <q-separator
          v-if="index < menuItems.length - 1"
          vertical
        />
      </template>
    </q-tabs>
  </q-footer>
</template>
